import Dexie from 'dexie'

const APP_TITLE = 'd-bok'

export const setDocumentTitle = pageTitle => {
  document.title = `${pageTitle} | ${APP_TITLE} `
}

/**
* Nested object merging helper
*/

export const mergeObjects = (target, ...sources) => {
  if (!sources.length) {
    return target
  }
  const source = sources.shift()

  if (source === undefined) {
    return target
  }

  if (isMergebleObject(target) && isMergebleObject(source)) {
    Object.keys(source).forEach(function (key) {
      if (isMergebleObject(source[key])) {
        if (!target[key]) {
          target[key] = {}
        }
        mergeObjects(target[key], source[key])
      } else {
        target[key] = source[key]
      }
    })
  }

  return mergeObjects(target, ...sources)
}

export const isObject = (item) => {
  return item !== null && typeof item === 'object'
}

export const isMergebleObject = (item) => {
  return isObject(item) && !Array.isArray(item)
}

// TODO: why its needed?
export const jsonData = (data) => {
  return JSON.parse(JSON.stringify(data))
}

export const isOnline = () => {
  return window.navigator.onLine ? 1 : 0
}

export const randomId = () => {
	const timestamp = (new Date().getTime() / 1000 | 0).toString(16)

  return timestamp + 'xxxxxxxxxxxxxxxx'.replace(/[x]/g, () => {
    return (Math.random() * 16 | 0).toString(16)
  }).toLowerCase()
}

// Reads blob and return text
export const readFileAsText = (inputFile) => {
  const temporaryFileReader = new FileReader()

  return new Promise((resolve, reject) => {
    temporaryFileReader.onerror = () => {
      temporaryFileReader.abort()
      reject(new Error('Problem parsing input file.'))
    }

    temporaryFileReader.onload = () => {
      resolve(temporaryFileReader.result.toString())
    }
    temporaryFileReader.readAsText(inputFile)
  })
}

export const responsive = () => {
  if (window.matchMedia("(min-width: 1366px)").matches) {
    return 'desktop'
  } else if (window.matchMedia("(min-width: 768px)").matches) {
    return 'tablet'
  }

  return 'mobile'
}

export const isMobileAgent = () => {
  const patternMobile = /Mobi/i,
  isMobile = patternMobile.test(navigator.userAgent)

  return isMobile
}

export const isEdgeAgent = () => {
  const patternEdge = /Edge\/\d+/i,
  isEdge = patternEdge.test(navigator.userAgent)

  return isEdge
}

export const isSafariAgent = () => {
  const patternSafari = /Safari\/\d+/i,
  isSafari = patternSafari.test(navigator.userAgent)

  return isSafari
}

export const clearIndexedDB = async () => {
  const dbs = await Dexie.getDatabaseNames()
  const removeDBs = await Promise.all(dbs.map(async db => await Dexie.delete(db)))

  return removeDBs
}

export const fetchProgress = async (response, progressUpdate) => {
  let receivedLength = 0
  const reader = response.body.getReader()
  const contentLength = response.headers.get('Content-Length')
  const { done, value } = await reader.read()
  const pingProgress = () => {
    if (!done) {
      requestAnimationFrame(pingProgress)
    }

    receivedLength += value.byteLength
    progressUpdate(receivedLength / contentLength * 100, contentLength)
  }

  requestAnimationFrame(pingProgress)
}

export const checkChapters = toc => {
  let noPages = true

  if (toc.length) {
    noPages = false
    toc.forEach(t => {
      if (t.pages.length === 0) {
        noPages = true
      }
    })
  }

  return noPages
}

export const getPageByIndex = (index) => {
  return parseInt(index, 10) + 1;
}

export const getPageName = (name) => {
  return name.split('.')[0]
}

export const getBookMetadata = (book, name, fallback) => {
  return (book && book.metadata) ?
    (typeof book.metadata[name] !== 'undefined' ? book.metadata[name]: fallback):
    fallback
}
